//通用类型名称
export const CURRENCY_STATE = {
    1: '未完成',
    2: '已完成'
}
//督导 状态
export const SUPERVISION = {
    1: '未督导',
    2: '已督导'
}

//状态列表
export const STATES = {
    enabled: 1,
    disabled: 0
};


//业主 签收 复查 照片
export const OWNER = {
    1: '无',
    2: '有'
}

export const SORT_ORDER = {
    1: '完成排查时间',
    2: '完成复查时间',
    3: '新增场所时间'
}
export const SORT = {
    1: '倒序',
    2: '正序'
}

export const MANAGEMENTLIST = {
    1:'正常',
    3: '停业',
    6: '停止出租',
    7: '正常',
    8: '装修',
    9: '自住',
    10: '正常',
    11: '停业',
    12: '正常',
    13: '停业',
    14: '正常',
    15: '停业',
    16: '装修',
    17: '倒闭',
    18: '空置',
    19: '空置',
    20: '装修',
    21: '倒闭',
    22: '装修',
    23: '空置',
    24: '倒闭',
    25: '装修',
    26: '正常',
    27: '正常',
    28: '重复',
    29: '重复',
    30: '重复',
    31: '重复',
    32: '重复',
    33: '重复',
    34: '重复'
}


export const ADOPT_STATE = {
    1: '未通过',
    2: '通过',
}

export const PLACE_FILTER = {
    0: '全部',
    1: '还有导出次数',
    2: '无导出次数',
}

